import sensorLabels from "./sensor-labels.json";
import shortSensorLabels from "./sensor-labels-short.json";
import sensorValues from "./sensor-values.json";

/**
 * Class with helper functions to get sensor labels and to translate raw values into human readable ones
 */
export class sensorInfo {
  static getLabel(sensorId: number): string {
    return sensorLabels[sensorId] || sensorId.toString();
  }

  static getShortLabel(sensorId: number): string {
    return shortSensorLabels[sensorId] || sensorId.toString();
  }

  static getValue(sensorValue: string): string {
    return sensorValues[sensorValue] || sensorValue;
  }
}
